<div
  class="resource-header flex flex-row items-center h-full justify-between py-1 pl-4 pr-4 border-b border-neutral-50 border-solid"
>
  <div class="flex flex-row items-center gap-x-6">
    <button
      (click)="back()"
      class="secondary small flx-ds"
      flxButton
      icon="center"
      data-testId="back-button"
      pTooltip="Go back to processes"
      tooltipPosition="bottom"
      tooltipStyleClass="text-sm"
    >
      <i
        [ngClass]="darkMode() ? 'text-white' : 'text-black'"
        class="ph ph-arrow-left leading-4 text-base"
        flxIcon
      ></i>
    </button>

    @if (breadcrumbs()?.length) {
      <flx-breadcrumbs
        [model]="breadcrumbs()"
        [ngClass]="darkMode() ? 'text-white' : 'text-black'"
        class="flx-resource-breadcrumbs text-xs"
      >
      </flx-breadcrumbs>
    }

    @if (errorBadgeCount() > 0) {
      <flx-severity-marker
        [count]="errorBadgeCount()"
        class="-ml-2"
        interactive
        severity="ERROR"
        data-testid="resource-header-error-badge"
      />
    }
  </div>

  <ng-content select="[resourceHeaderCenterContent]"></ng-content>

  <ng-content select="[resourceHeaderRightContent]"></ng-content>
</div>
